import React from "react";

export const LogoTitle = () => {
    return (
      <a href="/" className="text-black-800 inline-flex items-center gap-2.5 text-2xl font-bold md:text-3xl" aria-label="logo">
        <img src={`${process.env.REACT_APP_URL}/images/odoriba_logo.png`} alt="logo" width={75}/> 
        <img src={`${process.env.REACT_APP_URL}/images/odoriba_name.png`} alt="logo" width={150}/>
      </a>
    );
};